import config from "../../config/config";
import { Button } from "react-bootstrap";
import Fetch from "../../../core/util/core/Fetch";
import Toast from "../../../core/components/core/Util/Toast/Toast";
import { useEffect, useState } from "react";
import "./IbgeUpdate.css";
import { getUserSession } from "../../../core/util/core/Session";

let intervalId = false;
function IbgeUpdate() {
  const [disabledButton, setDisabledButton] = useState(false);
  const [textButton, setButtonText] = useState("Atualizar");
  const session = getUserSession();

  const udpateLocations = async () => {
    const response = await Fetch.post(
      config.endpoints.backend + "governanceroom/updateibgelocations/save",
      {
        status: "WAITING",
        core_application_instance_id: session.user.application_instance_id,
      },
    );
    if (response.status !== 0) {
      setDisabledButton(true);
      setButtonText("Atualizando...");
      createIntervalQuery();
    } else {
      Toast.error("Ocorreu um erro ao atualizar as tabelas do IBGE.");
    }
  };

  const createIntervalQuery = () => {
    intervalId = setInterval(async () => {
      const response = await Fetch.post(
        config.endpoints.backend + "governanceroom/updateibgelocations/getall",
      );
      setStatus(response);
    }, 5000);
  };

  const setStatus = async (info) => {
    switch (info.status) {
      case "PROCESSING":
        setDisabledButton(true);
        setButtonText("Atualizando...");
        break;
      case "DONE":
        setDisabledButton(false);
        setButtonText("Atualizar");
        Toast.success("Tabelas ibge atualizadas com sucesso!");
        if (intervalId !== false) {
          clearInterval(intervalId);
        }
        break;
      case "ERROR":
        setDisabledButton(false);
        setButtonText("Atualizar");
        Toast.error("Erro ao atualizar tabelas do ibge!");
        if (intervalId !== false) {
          clearInterval(intervalId);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    async function fetchIbgeTables() {
      const response = await Fetch.post(
        config.endpoints.backend + "governanceroom/updateibgelocations/getall",
      );

      if (response.status !== "DONE" && response.status !== "ERROR") {
        setStatus(response);
        createIntervalQuery();
      }
    }

    fetchIbgeTables();
    return () => {
      if (intervalId !== false) {
        clearInterval(intervalId);
      }
    };
  }, []);

  return (
    <>
      <section className="content" style={{ marginTop: "30px" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card card-outline card-info">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fa-solid fa-pen-to-square mr-1"></i>Atualizar
                    Tabelas IBGE
                  </h3>
                </div>
                <div className="ml-3 mt-5 mb-5">
                  <p>
                    Esta tela possui a única função de atualizar as tabelas do
                    IBGE consultando na api oficial.
                  </p>
                  <Button
                    style={{ width: "auto" }}
                    onClick={() => udpateLocations()}
                    disabled={disabledButton}
                  >
                    {textButton}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default IbgeUpdate;
